import {DEFAULT_HOST} from '@/utils/router'

export const domainResolutionServices = [
  {
    key: 'evaluation-and-consultation',
    imageSrc: '/images/icons/briefing.svg',
    imageAlt: 'Evaluation and consultation',
    title: 'domain-resolution.evaluation-and-consultation-title',
    description: 'domain-resolution.evaluation-and-consultation-desc',
  },
  {
    key: 'cease-and-desist-letter',
    imageSrc: '/images/icons/assessment.svg',
    imageAlt: 'Cease and desist letter',
    title: 'domain-resolution.cease-and-desist-letter-title',
    description: 'domain-resolution.cease-and-desist-letter-desc',
  },
  {
    key: 'dispute-resolution',
    imageSrc: '/images/icons/registration-support.svg',
    imageAlt: 'Dispute resolution',
    title: 'domain-resolution.dispute-resolution-title',
    description: 'domain-resolution.dispute-resolution-desc',
  },
]

export const getDomainResolutionContent = () => {
  return {
    metaTitle: 'domain-resolution.meta-title',
    metaDescription: 'domain-resolution.meta-desc',
    ogImage: {
      url: `${DEFAULT_HOST}/images/og-images/domain-resolution-en.png`,
      width: 1200,
      height: 627,
      alt: 'Domain resolution - OG image',
    },
    hero: {
      title: 'domain-resolution.hero-title',
      subtitle: 'domain-resolution.hero-subtitle',
      imageSrc: '/images/hero/chess.svg',
      imageAlt: 'Chess piece',
    },
    tiles: {
      title: 'domain-resolution.tiles-title',
      list: domainResolutionServices,
    },
    usp: {
      title: 'domain-resolution.explanation-title',
      threats: {
        title: 'domain-resolution.threats-title',
        features: [
          {
            title: 'domain-resolution.threat-title-0',
          },
          {
            title: 'domain-resolution.threat-title-1',
          },
          {
            title: 'domain-resolution.threat-title-2',
          },
        ],
      },
      competition: {
        title: 'domain-resolution.competition-title',
        features: [
          {
            title: 'domain-resolution.competition-title-0',
          },
          {
            title: 'domain-resolution.competition-title-1',
          },
          {
            title: 'domain-resolution.competition-title-2',
          },
        ],
      },
    },
    howItWorksSteps: [
      {
        title: 'domain-resolution.how-it-works-step-0-title',
        description: 'domain-resolution.how-it-works-step-0-desc',
        imageSrc: '/images/icons/consultation.svg',
        imageAlt: 'Consultation',
      },
      {
        title: 'domain-resolution.how-it-works-step-1-title',
        description: 'domain-resolution.how-it-works-step-1-desc',
        imageSrc: '/images/icons/gavel.svg',
        imageAlt: 'Legal action',
      },
      {
        title: 'domain-resolution.how-it-works-step-2-title',
        description: 'domain-resolution.how-it-works-step-2-desc',
        imageSrc: '/images/icons/validity.svg',
        imageAlt: 'Resolving issue',
      },
    ],
  }
}
